import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { CommonService } from "../../../../views/services/common.service";
import { HeaderService } from "../../../../views/services/header.service";
import { LandingService } from "../../../../views/services/landing.service";
import { ConsultantsService } from "../../accmgr/services/consultants.service";
import { SearchData } from "../../common/models/search";
import { AccomSupportService } from "../../common/services/accomsupport.service";
import { DownloadDocumentService } from "../../common/services/downloaddocument.service";

@Component({
  selector: "app-accsupportlanding",
  templateUrl: "./accsupportlanding.component.html",
  styleUrls: ["./accsupportlanding.component.css"]
})
export class AccSupportLandingComponent implements OnInit, OnDestroy {
  public accomSupportForm: FormGroup;
  public filteredData = [];
  public infoMsg: string;
  public personId: any;
  public searchCount: number;
  public searchData: SearchData = {};
  public rscValues: any = [];
  public assignedData: any = [];
  public myRequestData: any = [];
  public completedData: any = [];
  public autoApprovedData: any = [];
  public tests: any = [];
  public testDates: any = [];
  public currentTab: string;
  public tabList: string[];
  public tableData: any = {};
  public statusPanelData: any = {};
  public assigneeOptions: any;
  public consultant: any;
  public itemstoUpdate = [];
  public consultantId: any;
  public recordUpdate: boolean = false;
  public emptyItem: boolean = false;
  public assignedStatusCode: string = "";
  public sizes: any;
  public selectedAll: any;
  public selected = [];
  public fromDateError: boolean = false;
  public toDateError: boolean = false;
  public dateError: boolean = false;
  public dateErrorMsg: string = "";
  public savedCurrentTab: string = "";
  public user: any;
  public loggedInConsultantId: any;
  public autoAppConsultantId: any;
  public searchclicked: boolean;

  constructor(
    public headerService: HeaderService,
    private analystsService: ConsultantsService,
    private landingService: LandingService,
    public accomSupportService: AccomSupportService,
    public commonService: CommonService,
    private downloadDocumentService: DownloadDocumentService
  ) {}

  ngOnInit() {
    this.setSearchDefaultValue();
    Observable.forkJoin(
      this.analystsService.getActiveConsultants(),
      this.landingService.getRequestStatusCodes(),
      this.landingService.getTest()
    ).subscribe(([resp, rsc, tests]) => {
      this.consultant = resp;
      this.consultant.forEach((item, index, object) => {
        if (item.USER_NM === "SYSTEM") {
          this.autoAppConsultantId = item.CONSULTANT_ID;
          object.splice(index, 1);
        }
      });

      this.rscValues = rsc;
      this.rscValues.forEach((item, index, object) => {
        if (item.STATUS_CD === "Assigned") {
          this.assignedStatusCode = item.REQUEST_STATUS_CODE_ID;
        }
      });
      this.tests = tests;
    });
  }

  downloadFile(event, item: any, fileName) {
    this.downloadDocumentService.downloadFile(fileName, item);
    event.stopPropagation();
    event.preventDefault();
  }

  ngOnDestroy() {}

  setSearchDefaultValue() {
    this.tableData = [];
    this.searchCount = 0;
    this.dateError = false;
    this.toDateError = false;
    this.fromDateError = false;
    this.searchclicked = false;
    this.searchData.status = "";
    this.searchData.consultantId = "";
    this.searchData.testDateId = "";
    this.searchData.testNameId = "";
    this.searchData.fromDate = "";
    this.searchData.firstNm = "";
    this.searchData.lastNm = "";
    this.searchData.taaPin = "";
    this.searchData.organizationName = "";
    this.searchData.toDate = "";
  }
  search() {
    if (this.searchData.firstNm) {
      this.searchData.firstNm = this.searchData.firstNm.trim();
    }
    if (this.searchData.lastNm) {
      this.searchData.lastNm = this.searchData.lastNm.trim();
    }
    if (this.searchData.taaPin) {
      this.searchData.taaPin = this.searchData.taaPin.trim();
    }

    Observable.forkJoin(this.landingService.getSearchData(this.searchData))
      .finally(() => {})
      .subscribe(([response]) => {
        if (response) {
          this.recordUpdate = false;
          this.searchCount = 0;
          this.tableData = [];
          this.assignedData = [];
          this.completedData = [];
          this.autoApprovedData = [];
          this.myRequestData = [];
          this.tableData = response.body;
          this.searchCount = this.tableData.length;
          this.tableData.forEach(element => {
            if (element.REASONS) {
              element.REASONS = element.REASONS.replace(/\|/g, ",");
            }
            if (element.EXAMINEE_ACCOMMS) {
              element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(
                /\|/g,
                ","
              );
            }
            if (element.CONSULTANTS) {
              element.CONSULTANTS = element.CONSULTANTS.replace(/\|/g, ",");
            }
          });
        }
      });
  }

  checkSearch() {
    this.searchclicked = false;
    this.toDateError = false;
    this.dateError = false;
    this.fromDateError = false;
    for (let i = 0; i < Object.keys(this.searchData).length; i++) {
      if (this.searchData[Object.keys(this.searchData)[i]]) {
        this.searchclicked = true;
        break;
      }
    }
    if (this.searchclicked) {
      if (this.searchData.fromDate && this.searchData.fromDate !== null) {
        this.searchData.fromDate = moment(this.searchData.fromDate).format(
          "MM-DD-YYYY"
        );
        if (this.searchData.fromDate === "Invalid date") {
          this.fromDateError = true;
        } else {
          this.fromDateError = false;
        }
      }
      if (this.searchData.toDate && this.searchData.toDate !== null) {
        this.searchData.toDate = moment(this.searchData.toDate).format(
          "MM-DD-YYYY"
        );
        if (this.searchData.toDate === "Invalid date") {
          this.toDateError = true;
        } else {
          this.toDateError = false;
        }
      }
      if (
        this.searchData.fromDate &&
        this.searchData.toDate &&
        this.searchData.fromDate !== null &&
        this.searchData.toDate !== null
      ) {
        if (moment(this.searchData.toDate).isAfter(this.searchData.fromDate)) {
          this.dateError = false;
        } else {
          this.dateError = true;
          this.dateErrorMsg =
            "Submitted To Date Should be Greater Submitted From Date";
        }
      } else if (
        this.searchData.fromDate &&
        this.searchData.fromDate !== null &&
        !this.searchData.toDate
      ) {
        this.dateError = true;
        this.dateErrorMsg = "Please select a Submitted To Date";
      } else if (
        !this.searchData.fromDate &&
        this.searchData.toDate !== null &&
        this.searchData.toDate
      ) {
        this.dateError = true;
        this.dateErrorMsg = "Please select a Submitted From Date";
      }
      if (!(this.dateError || this.toDateError || this.fromDateError)) {
        this.search();
      }
    } else {
      document.getElementById("searchModal").style.display = "block";
    }
  }
  clearForm() {
    this.ngOnInit();
  }
  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
    this.clearForm();
  }
  onSelectedDropDownValue() {
    this.testDates = [];
    Observable.forkJoin(
      this.landingService.getTestDatesByTest(this.searchData.testNameId)
    ).subscribe(([testDates]) => {
      this.testDates = testDates.body;
    });
  }

  sendStudentDetails(examinee: any) {
    const studentDetails = {
      personId: examinee.PERSON_ID,
      requestId: examinee.REQUEST_ID,
      consultantId: examinee.CONSULTANT_ID ? examinee.CONSULTANT_ID : "",
      taaPin: examinee.ACCOMMS_PIN ? examinee.ACCOMMS_PIN : "",
      organizationName: examinee.ORGANIZATION_NM
        ? examinee.ORGANIZATION_NM
        : "",
      firstNm: examinee.PNFIRSTNAME ? examinee.PNFIRSTNAME : "",
      lastNm: examinee.PNLASTNAME ? examinee.PNLASTNAME : ""
    };
    sessionStorage.setItem(
      "internalStudentDetails",
      JSON.stringify(studentDetails)
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/accsupportlanding/accsupportlanding.component.ts